import {
    HostBinding,
    Input, Directive,
} from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';

import { Resolutions } from '@core/domain/state/core.state';
import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import { NewsletterPublicModels } from '@features/newsletter/public.api';

@Directive({
    selector: '[common-styles-render]',
})
export abstract class CommonStylesRenderDirective {
    @Input() public element: ContentItemTree;

    @Input() public direction: string;

    @Input() public resolution: Resolutions;

    @Input() public newsletterCmsSettings: NewsletterPublicModels.NewsletterCmsSettings;

    /*
    * GENERAL
    * */
    @HostBinding('attr.id')
    public id: string;

    @HostBinding('style.display')
    public display: string = 'flex';

    @HostBinding('style.width')
    public width: string = '100%';

    @HostBinding('style.height')
    public height: string = 'auto';

    @HostBinding('style.pointer-events')
    public pointerEvents: string = 'auto';

    @HostBinding('style.position')
    public position: string = 'relative';

    @HostBinding('style.background-color')
    public backgroundColor!: string;

    @HostBinding('style.background-position')
    public backgroundPosition!: string | undefined;

    @HostBinding('style.background-repeat')
    public backgroundRepeat!: string | undefined;

    @HostBinding('style.background-size')
    public backgroundSize!: string | undefined;

    @HostBinding('style.background-attachment')
    public backgroundAttachment!: string | undefined;

    @HostBinding('style.background-image')
    public backgroundImage: SafeStyle | undefined;

    /*
    * FLEXBOX
    * */
    @HostBinding('style.flex')
    public flex: string = '1 1 100%';

    public respConfig: any;

    public backgroundImageSetting: any;

    public setDefaultHostStyles() {
        this.id = this.element.definitionId + '-' + this.element?.id.split('-')[0];
        if (this.element.settings.styles === undefined) {
            return;
        }

        this.backgroundColor = this.element.settings.styles.bgColor;
        this.backgroundPosition = this.element.settings.styles.backgroundPosition;
        this.backgroundImageSetting = this.element.settings.styles.backgroundImage;

        if (this.element.definitionId === 'slice-flex' && this.backgroundImageSetting) {
            this.backgroundPosition = this.backgroundImageSetting.position ?? 'top';
            this.backgroundRepeat = this.backgroundImageSetting.repeat ?? 'no-repeat';
            this.backgroundSize = this.backgroundImageSetting.size ?? 'cover';
            this.backgroundAttachment = this.backgroundImageSetting.fixed ?? 'fixed';
        }
    }

    public toUnit(value: number | string): string {
        return typeof value === 'number' ? `${value}%` : value;
    }
}
